import { Tabs } from '@mui/material';
import styled from '@mui/material/styles/styled';
const StyledTabs = styled(Tabs, {
  shouldForwardProp: (prop) => prop !== 'compact',
})(({ theme, compact }) => ({
  // if compact, reduce the size of the tabs
  ...(compact && {
    minHeight: 0,
    minWidth: 0,
    '& .MuiTab-root': {
      minHeight: 0,
      minWidth: 0,
      padding: theme.spacing(1, 2),
    },
    '& .MuiTabs-indicator': {
      height: 3,
    },
    '& .MuiBadge-badge.MuiBadge-anchorOriginTopRight': {
      top: 2,
      right: -6,
    },
  }),
  '& .MuiTab-root .MuiTypography-root': {
    color: 'inherit',
  },
}));

export default StyledTabs;
